import { useEffect } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import LinkButton from '@ilg-totallymoney/ui/components/LinkButton'

import ErrorPage from '@components/ErrorPage'

import { LoggerKey } from '@config/logger'

import useLogger from '@hooks/useLogger'

import { getAppConfig } from '@utils/getAppConfig'
import { getIsExpiredScorePageError } from '@utils/getIsExpiredScorePageError'

interface AlternativeProductsTableErrorProps {
    error?: unknown
}

const AlternativeProductsTableError = ({
    error,
}: AlternativeProductsTableErrorProps) => {
    const { logInfo } = useLogger()

    const isExpiredScorePageError = getIsExpiredScorePageError(error)

    function onOffersRedirect() {
        logInfo(LoggerKey.AlternativeProductsErrorOffersRedirect, {})
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            logInfo(LoggerKey.AlternativeProductsErrorView, {
                expired: isExpiredScorePageError,
            })
        }
    }, [])

    if (isExpiredScorePageError) {
        return (
            <ErrorPage
                title="Something went wrong!"
                subtitle="Please log in to check your eligibility for credit cards"
            >
                <Box pt="space30" maxWidth={['100%', '280px']}>
                    <LinkButton
                        variant="primary"
                        text="Log in"
                        href={`${getAppConfig().ACCOUNT_URL}offers`}
                        onClick={onOffersRedirect}
                    />
                </Box>
            </ErrorPage>
        )
    }

    return (
        <ErrorPage
            title="Something went wrong!"
            subtitle="Oops! The credit cards service is unavailable right now."
        >
            <Box pt="space30" maxWidth={['100%', '280px']}>
                <LinkButton variant="primary" text="Try again" href="" />
            </Box>
        </ErrorPage>
    )
}

export default AlternativeProductsTableError
